import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { MdOutlineEmojiEmotions } from 'react-icons/md';
import cognoviLogo from '../../assets/cognovi-logo.png';
import QdtComponent from '../../components/QdtComponent';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';

export default function Emotions() {
	const {goToTop, clearAllSelections} = useApp()

	useEffect(() => {
    // goToTop()
  }, [goToTop])

  return (
    <motion.div variants={fadeIn} initial="hidden" animate="show">
			<section className="section-space bg-emotions-img bg-overlay">
					<div className="container">
						<div className="row rowsafari">
							<div className="col-lg-12">
								<div className="row">
									<MdOutlineEmojiEmotions color={'white'} size={54}/>
									<h3 className="text-white text-center pt-2">Emotions</h3>
								</div>
							</div>
						</div>
					</div>
			</section>

			<section className="container section-gray-bg" id="contact">
				<div className="container pt-3 pb-3">
					<div className="row rowsafari">
						<div className="col res-desk-mar-bot">
							<div className="header-box">
								<div className="section-margin-bottom">
									<h6 className="text-light section-margin-bottom text-start">
										IPC Global is introducing the power of Cognovi during this 
										interactive Masters Pool application. Cognovi measures what 
										people feel (emotions) and what they will do next by 
										quantifying the psychology of the human decision-making 
										process. Today, facts and sentiments solutions only highlight 
										what people say and how they say it, not what they will do 
										next. IPC Global has integrated two best-in-class solutions 
										Qlik and Cognovi's powerful narrative analytics, to look at 
										fans, journalists, and golfer's emotions at The Masters. 
									</h6>
								</div>
								<hr />
								<div className="section-margin-bottom">
									<h6 className="theme-color section-margin-bottom text-start">
										A simple 1-100 scale enables you to quickly understand the 
										emotional undertones of the posts during the tournament. 
										Posts higher than 50 are engaged, activated, and reacting 
										to the highs and lows of watching their favorite athletes 
										play The Masters. To learn more about how IPC Global can 
										help your organization, click contact us in the "About IPC 
										Global" section.
									</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
				
			<section className="container section-white-bg pt-5 header-box-opacity">
				<div className="container ">
					<div className="row rowsafari">
						<div className="col-lg-3 col-md-6 col-sm-12">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'gCYNaMe',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-12 ">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'TUvkJ',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-12 ">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'ZPtfrFq',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-12 ">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'bnpkjN',
									height: '120px'
								}}
							/>
						</div>
					</div>
				</div>
			</section>

			<section className="container section-white-bg pt-5 mb-3">
				<div className="container bg-white">
					<div className="row rowsafari">
					<div className="col-lg-2 col-md-2 col-sm-12">
							<div className="row text-start header-box">
								<img src={cognoviLogo}  alt="cognovi logo"/>
							</div>
						</div>
						<div className="col-lg-8 col-md-8 col-sm-12 section-margin-top-bottom">
							<QdtComponent
								type='QdtFilter'
								props={{
									cols: ['Player'],
									placeholder: 'Player Search...',
									expanded: true
								}}
							/>
						</div>
						<div className="col-lg-2 col-md-2 col-sm-12">
							<div className="row text-start">
							<button onClick={() => clearAllSelections()} className="btn btn-warning text-success">Clear Selections</button>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="container section-gray-bg">
				<div className="pt-5 pb-5">
					<div className="row rowsafari">
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'gfaLk',
									height: '120px'
								}}
							/>
						</div>

						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'mqKFagQ',
									height: '120px'
								}}
							/>
						</div>

						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'tvKGmj',
									height: '120px'
								}}
							/>
						</div>

						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'vacPnG',
									height: '120px'
								}}
							/>
						</div>

					</div>
				</div>
			</section>

			<section className="container section-white-bg">
				<div className="pt-5 pb-5">
					<div className="row rowsafari">
						<div className="col-lg-3 col-md-6 col-sm-12">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'mgQzS',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'GEeJdZp',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'BuqCCq',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'rQZm',
									height: '120px'
								}}
							/>
						</div>

					</div>
				</div>
			</section>

			<section className="container section-gray-bg">
				<div className="pt-5 pb-5">
					<div className="row rowsafari justify-content-evenly">
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'NMyRUq',
									height: '120px'
								}}
							/>
						</div>
						<div className="col-lg-3 col-md-6 col-sm-6 col-6">
							<QdtComponent
								type="QdtViz"
								props={{
									id: 'rQZm',
									height: '120px'
								}}
							/>
						</div>

					</div>
				</div>
			</section>
  	</motion.div>
  )
}